import { render, staticRenderFns } from "./FormEmpresaEditarContratoAlvorada.vue?vue&type=template&id=5ebefc07&lang=pug"
import script from "./FormEmpresaEditarContratoAlvorada.vue?vue&type=script&lang=js"
export * from "./FormEmpresaEditarContratoAlvorada.vue?vue&type=script&lang=js"
import style0 from "./FormEmpresaEditarContratoAlvorada.vue?vue&type=style&index=0&id=5ebefc07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports